import { map } from 'ramda'
import { getOffers, getOfferById, shareOffer } from '../../utils/api'
import { recordUsageData } from '../../utils/api/usage'
import LocalStorage from '../../utils/LocalStorage'
import initialFilters from './initialFilters'

export default {
  async loadOffers({ commit, dispatch, rootState }) {
    commit('setLoading', true)

    const { id: contactId } = rootState.auth.user.data.attributes

    const offers = await getOffers({ contactId }).catch((error) => {
      dispatch('notifications/flash/create', {
        type: 'error',
        content: 'Error fetching offers',
      }, { root: true })

      throw error
    })

    dispatch('setOffers', offers)
    commit('setLoading', false)
  },
  async loadOffer({ dispatch }, id) {
    dispatch('setOffer', await getOfferById(id))
  },
  setOffers({ commit }, offers) {
    map((offer) => LocalStorage.offer(offer.id).apply(offer), offers)
    commit('setOffers', offers)
  },
  setOffer({ commit }, offer) {
    LocalStorage.offer(offer.id).apply(offer)
    commit('setOffer', offer)
  },
  updateOffer({ commit }, offer) {
    LocalStorage.offer(offer.id).update(offer)
    commit('setOffer', offer)
  },
  setFilters({ commit, state, rootState }, [offerId, filters]) {
    const currentFilters = state.filters[offerId] || initialFilters()
    const updatedFilters = { ...currentFilters, ...filters }
    commit('setFilters', { [offerId]: updatedFilters })

    LocalStorage.offerFilters(offerId).update(updatedFilters)

    const {
      isAuthenticated,
      user,
    } = rootState.auth

    if (isAuthenticated) {
      const {
        id: contactIri,
      } = user.data

      recordUsageData(contactIri, 'setFilters', {
        // TODO: Confirm this format
        changes: filters,
        filters: updatedFilters,
      })
    }
  },
  clearFilters({ commit, state, rootState }, offerId) {
    commit('setFilters', { [offerId]: undefined })

    LocalStorage.offerFilters(offerId).update(undefined)

    if (rootState.auth.isAuthenticated) {
      recordUsageData(rootState.auth.user.data.id, 'resetFilters', {
        // TODO: Confirm this format
        filtersWere: state.filters,
      })
    }
  },
  async share({ state, rootState, dispatch }, { offerId, emailAddresses, message }) {
    const {
      isAuthenticated,
      user,
    } = rootState.auth

    if (!isAuthenticated || !user) {
      dispatch('notifications/flash/create', {
        type: 'error',
        content: 'You need to be logged in to share an offer.',
      }, { root: true })
    } else {
      const { offers } = state
      const offer = offers[offerId]

      const {
        data: {
          id: contactIri,
        },
      } = rootState.auth.user

      if (offer) {
        await shareOffer({
          offer,
          message,
          contact: contactIri,
          emailList: emailAddresses,
        }).catch((e) => {
          dispatch('notifications/flash/create', {
            type: 'error',
            content: 'Failed to share the offer.',
          }, { root: true })
          throw e
        })

        dispatch('notifications/flash/create', {
          type: 'success',
          content: `Shared ${offer.name} with your chosen recipients.`,
        }, { root: true })
      } else {
        dispatch('notifications/flash/create', {
          type: 'error',
          content: 'Failed to share the offer.',
        }, { root: true })

        throw new Error('Missing offer')
      }
    }
  },
}
